<template>
  <AttitudesCard />
</template>

<script>
import AttitudesCard from '@/components/attitudesCard.vue';

export default {
  components: {
    AttitudesCard,
  },
};
</script>

<style></style>
